import type { SegySetupType } from '@core/core/types'
import type { BaseObject } from 'common/types'

import type { ElementType as ApiElementType2 } from '../GeologyClient/__generated__/data-contracts'
import type { ElementType as ApiElementType1 } from '../ObjectTreeClient/__generated__/data-contracts'

export function convertSetupContent(setupContent: SegySetupType) {
  const { headerCoords, samples } = setupContent
  const { surveyName, surveyType, domainType, ignoreSegy, check, ignoreZeros } = setupContent

  return {
    ...setupContent,
    headerOffsets: {
      x: headerCoords?.x?.offset ?? NaN,
      y: headerCoords?.y?.offset ?? NaN,
      iline: headerCoords?.iline?.offset ?? NaN,
      xline: headerCoords?.xline?.offset ?? NaN,
    },
    headerTypes: {
      x: headerCoords?.x?.type ?? 'INT_4_BYTES',
      y: headerCoords?.y?.type ?? 'INT_4_BYTES',
      iline: headerCoords?.iline?.type ?? 'INT_4_BYTES',
      xline: headerCoords?.xline?.type ?? 'INT_4_BYTES',
    },
    samples: {
      samplesFormat: samples?.samplesFormat ?? 'INT_4_BYTES',
      samplesPerTrace: samples?.samplesPerTrace ?? NaN,
      interval: samples?.interval ?? NaN,
      startRecord: samples?.startRecord ?? NaN,
      scale: samples?.scale ?? NaN,
    },
    surveyName,
    surveyType,
    domainType,
    ignoreSegy,
    check,
    ignoreZeros,
  }
}

export function convertToApiElementType(from: BaseObject): ApiElementType1 | ApiElementType2 {
  switch (from) {
    case 'well':
      return 'Well'
    case 'field':
      return 'Field'
    case 'cube':
      return 'Survey3DFolder'
    case 'fault':
      return 'Fault'
    case 'horizon':
      return 'Horizon'
    case 'survey2d':
      return 'Survey2DFolder'
    case 'inclinometry':
      return 'Inclinometry'
    case 'marker':
      return 'Marker'
    case 'gis':
      return 'GIS'
    case 'iLine':
      return 'ILine'
    case 'xLine':
      return 'XLine'
    case 'Hline':
      return 'ZSlice'
    case 'profile':
      return 'Profile'
    case 'polygon':
      return 'Polygon'
    case 'map':
      return 'Map'
    case 'stick':
      return 'Stick'
    case 'wellBore':
      return 'WellBore'
    case 'lithology':
      return 'Lithology'
    case 'saturation':
      return 'Saturation'
    case 'vsp':
      return 'VSP'
    case 'interpretation3D':
      return 'Interpretation3D'
    case 'interpretation2D':
      return 'Interpretation2D'
    case 'faultsFolder':
      return 'FaultsFolder'
    case 'points':
      return 'Points'
    case 'wellsFolder':
      return 'WellsFolder'
    case 'gisFolder':
      return 'GISFolder'
    case 'rigisFolder':
      return 'RIGISList'
    case 'markersFolder':
      return 'MarkersFolder'
    case 'seismicFolder':
      return 'SeismicFolder'
    case 'seismicSurveys':
      return 'SeismicSurveys'
    case 'interpretation':
      return 'Interpretation'
    case 'horizonsFolder':
      return 'HorizonsFolder'
    case 'sticksFolder':
      return 'SticksFolder'
    case 'polygonsFolder':
      return 'PolygonsFolder'
    case 'mapsFolder':
      return 'MapsFolder'
    case 'pointsFolder':
      return 'PointsFolder'
    case 'gisList':
      return 'GISList'
    case 'rigisList':
      return 'RIGISFolder'
    case 'vspList':
      return 'VSPList'
    case 'markerList':
      return 'MarkerList'
    case 'velocityModel':
      return 'VelocityModel'
    case 'velocityModelsFolder':
      return 'VelocityModelsFolder'
    case 'virtualFolder':
      return 'VirtualFolder'
    case 'speedLawsFolder':
      return 'SpeedLawsFolder'
    case 'gisName':
    case 'grid':
    case 'unknown':
    case 'cut':
    case 'iLineCut':
    case 'xLineCut':
    case 'hLineCut':
      return 'None'
  }
}
